export default {
      id: "graph-serve-usage",
      viewBox: "0 0 96 63",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-serve",
      toString: function () {
        return this.url;
      }
    }